import * as effects from 'redux-saga/effects';
import { IApplicationState } from '..';

import { Backend } from '../../Backend/Backend';
import { ICallState } from '../../Backend/Messages/callSuccess';
import { Logger } from '../../Utils/Logger';
import { TypedStorage } from '../../Utils/TypedStorage';
import { IUserState } from '../User/Types';

import {
    getProgramTypes, getProgramTypesSuccess, getProgramTypesError,
    getProgramEditors, getProgramEditorsSuccess, getProgramEditorsError,
    getAutocompletePerson, getAutocompletePersonSuccess,
    getMediasSource, getMediasSourceSuccess,
    getPoliticalGroupSpecific, getPoliticalGroupSpecificSuccess,
} from './Actions';
import {
    IAutocompletePerson,
    IPoliticalGroupSpecific,
    IProgramType,
    ISearchActionTypes
} from './Types';

function* handleGetProgramTypes(action: ReturnType<typeof getProgramTypes>) {
    const backend = Backend.getInstance();

    const res: ICallState = yield effects.apply(backend, backend.getProgramTypes, [action.payload]);
    if (res.status_code === 200) {

        if (res !== null) {
            yield effects.put(getProgramTypesSuccess(res.results as IProgramType[]));
        }
    } else {
        Logger.warn('Failed handleGetProgramTypes');
        yield effects.put(getProgramTypesError(res.results));
    }
}

function* handleGetProgramEditors(action: ReturnType<typeof getProgramEditors>) {
    const backend = Backend.getInstance();
    const res: ICallState = yield effects.apply(backend, backend.getProgramEditors, [action.payload]);
    if (res.status_code === 200) {

        if (res !== null) {
            yield effects.put(getProgramEditorsSuccess(res.results as IProgramType[]));
        }
    } else {
        Logger.warn('Failed handleGetProgramEditors');
        yield effects.put(getProgramEditorsError(res.results));
    }
}
function* handleGetPersonAutocomplete(action: ReturnType<typeof getAutocompletePerson>) {
    const backend = Backend.getInstance();

    const user: IUserState = yield effects.select((state: IApplicationState) => state.user);
    const res: ICallState = yield effects.apply(backend, backend.getAutocompletePerson, [user.token, action.payload]);
    if (res.status_code === 200) {

        if (res !== null) {
            yield effects.put(getAutocompletePersonSuccess(res.results as IAutocompletePerson[]));
        }
    } else {
        Logger.warn('Failed handleGetPersonAutocomplete');
    }
}
function* handleGetMediasSource(action: ReturnType<typeof getMediasSource>) {
    const backend = Backend.getInstance();

    const token = TypedStorage.get('userToken', '')
    const res: ICallState = yield effects.apply(backend, backend.getMediasSource, [token, action.payload]);
    if (res.status_code === 200) {

        if (res !== null) {
            yield effects.put(getMediasSourceSuccess(res.results));
        }
    } else {
        Logger.warn('Failed handleGetMediasSource');
    }
}

function* handleGetPoliticalGroup(action: ReturnType<typeof getPoliticalGroupSpecific>) {
    const backend = Backend.getInstance();

    const user: IUserState = yield effects.select((state: IApplicationState) => state.user);
    const res: ICallState = yield effects.apply(backend, backend.getPoliticalGroupSpecific, [user.token, action.payload]);
    if (res.status_code === 200) {

        if (res !== null) {
            yield effects.put(getPoliticalGroupSpecificSuccess(res.results as IPoliticalGroupSpecific[]));
        }
    } else {
        Logger.warn('Failed handleGetPoliticalGroup');
    }
}
function* watchSearch() {
    yield effects.takeEvery(ISearchActionTypes.GET_PROGRAM_TYPES, handleGetProgramTypes);
    yield effects.takeEvery(ISearchActionTypes.GET_PROGRAM_EDITORS, handleGetProgramEditors);
    yield effects.takeEvery(ISearchActionTypes.GET_AUTOCOMPLETE_PERSON, handleGetPersonAutocomplete);
    yield effects.takeEvery(ISearchActionTypes.GET_MEDIAS_SOURCE, handleGetMediasSource);
    yield effects.takeEvery(ISearchActionTypes.GET_POLITICAL_GROUP_SPECIFIC, handleGetPoliticalGroup);
}

export function* SearchSaga() {
    yield effects.all([
        effects.fork(watchSearch),
    ]);
}
